<!--  / eslint-disable no-new / -->
<template>
  <div
    :class="[
      'run-code-content',
      'training-area-right',
      { 'training-area-right-off': !sidebarSwitch },
    ]"
  >
    <!-- 运行工具edit-tool -->
    <!-- <div :class="['edit-tool', { 'edit-tool-off': !workspaceIsVisible }]">
      <el-button class="btn-undo-redo" title="撤销" @click="undoHandle">
        <icon-base
          class="icon-undo-redo icon-undo"
          :icon-name="Icons.UndoOrRedo.undo"
          v-bind="Icons.UndoOrRedo.data"
        >
          <icon-undo-or-redo />
        </icon-base>
      </el-button>
      <el-button class="btn-redo-redo" title="重做" @click="redoHandle">
        <icon-base
          class="icon-undo-redo icon-redo"
          :icon-name="Icons.UndoOrRedo.redo"
          v-bind="Icons.UndoOrRedo.data"
        >
          <icon-undo-or-redo />
        </icon-base>
      </el-button>
      <el-button title="整理" @click="resetSvg">
        <icon-base
          class="icon-undo-redo icon-redo"
          :icon-name="Icons.DeskToday.iconName"
          v-bind="Icons.DeskToday"
        >
          <icon-desk-today />
        </icon-base>
      </el-button>
    </div> -->
    <div class="run-head">
      <div v-show="false" class="title">数据运算</div>
      <el-button @click="codeRunHandle" v-show="sidebarSwitch">
        <icon-base
          id="button_run"
          class="icon-code-run"
          :icon-base="Icons.CodeRun.iconName"
          v-bind="Icons.CodeRun"
        >
          <icon-code-run />
        </icon-base>
        运行
      </el-button>
      <el-button @click="clearWorkspace" v-show="sidebarSwitch">
        <icon-base
          class="icon-code-clear"
          :icon-base="Icons.CodeClear.iconName"
          v-bind="Icons.CodeClear"
        >
          <icon-code-clear />
        </icon-base>
        清除
      </el-button>

      <el-button
        v-show="sidebarSwitch && ifCreateBlock"
        @click="confirmNewBlock"
        :class="[!ifCreateBlock ? 'none-click' : '']"
        :style="{ 'pointer-events': ifCreateBlock ? 'auto' : 'none' }"
      >
        确定建积木
      </el-button>
      <el-button
        :class="{ 'sibebar-switch-off': !sidebarSwitch }"
        @click="sidebarSwitchHandle"
      >
        <icon-base
          class="icon-sibebar-switch"
          :icon-name="Icons.SidebarSwitch.iconName"
          v-bind="Icons.SidebarSwitch"
        >
          <icon-sibebar-switch />
        </icon-base>
      </el-button>
    </div>
    <!-- 代码运行结果模块 -->
    <div class="run-result">
      <div
        id="runMsgSuccess"
        :class="['run-msg-success', { 'run-msg-hide': !runStasus }]"
      >
        <i class="icon_box" v-show="runStasus === 'success'">
          <icon-base
            class="icon-run-success"
            :icon-name="Icons.RunSuccess.iconName"
            v-bind="Icons.RunSuccess"
          >
            <icon-run-success />
          </icon-base>
        </i>
        {{ Message.runCode[runStasus] }}
        <span class="error-btn" v-show="runStasus == 'fail'" @click="showError"
          >报错信息>
        </span>
        <p class="error-info" v-show="errorStatus">{{ errorText }}</p>
      </div>
      <!-- 运行区结果 -->
      <div
        id="runMsgCmd"
        class="run-msg-cmd"
        v-for="(item, index) of codeResult"
        :key="index"
      >
        {{ item }}
      </div>
    </div>

    <div
      :class="['run-ai', { 'run-ai-full-screen': isFullScreen }]"
      ref="runAi"
      id="run-ai"
    >
      <div class="run-ai-head">
        <!-- <span class="title ellipsis">{{
          Train.trainingName || Project.projectName
        }}</span> -->
        <tooltip-box
          class="title"
          :textRef="'trainingNametips'"
          :textId="'123456'"
          :textRow="1"
          :textName="Train.trainingName || Project.projectName"
          :placement="'top'"
          :tooltipShow="false"
        ></tooltip-box>
        <el-button
          class="full-screen"
          :title="
            isFullScreen
              ? Icons.ExitFullScreen.iconName
              : Icons.FullScreen.iconName
          "
          @click="fullScreen"
        >
          <icon-base
            class="icon-full-screen"
            :icon-name="Icons.FullScreen.iconName"
            v-bind="Icons.FullScreen"
            v-show="!isFullScreen"
          >
            <icon-full-screen />
          </icon-base>
          <icon-base
            class="icon-full-screen"
            :icon-name="Icons.ExitFullScreen.iconName"
            v-bind="Icons.ExitFullScreen"
            v-show="isFullScreen"
          >
            <icon-exit-full-screen />
          </icon-base>
        </el-button>
      </div>
      <!-- 海龟库显示区  -->
      <div
        :class="[
          'run-ai-area',
          {
            'run-ai-area-bg-remove':
              runStasus == 'success' || runStasus == 'loading',
          },
        ]"
      >
        <pre
          id="skulpt-turtle"
          :class="['canvas-wrap', { 'canvas-wrap-full': isFullScreen }]"
        ></pre>
      </div>
    </div>
    <!--  -->
  </div>
</template>

<script>
// api
// import gtaAudio from '@/components/common/Audio'
import { mapGetters } from 'vuex'
// 图标
import IconUndoOrRedo from '@/components/icons/typography/UndoOrRedo'
import IconDeskToday from '@/components/icons/typography/DeskToday'
import IconSibebarSwitch from '@/components/icons/typography/SidebarSwitch'
import IconCodeRun from '@/components/icons/typography/CodeRun'
import IconCodeClear from '@/components/icons/typography/CodeClear'
import IconRunSuccess from '@/components/icons/typography/RunSuccess'
import IconFullScreen from '@/components/icons/typography/FullScreen'
import IconExitFullScreen from '@/components/icons/typography/ExitFullScreen'
import TooltipBox from '@/components/common/TooltipBox'
//公共方法
import bus from '@/utils/bus'
require('skulpt/dist/skulpt.min.js')
require('skulpt/dist/skulpt-stdlib.js')
var Sk = window.Sk
export default {
  name: 'PythonCodeRun',
  components: {
    // gtaAudio,
    IconUndoOrRedo,
    IconDeskToday,
    IconSibebarSwitch,
    IconCodeRun,
    IconCodeClear,
    IconRunSuccess,
    IconFullScreen,
    IconExitFullScreen,
    TooltipBox
  },
  props: {
    codeText: {
      type: String,
      default: '',
    },
    projectId: {
      type: String,
      default: null,
    },
    Project: {
      type: Object,
      default: () => {
        return {}
      },
    },
    workspaceIsVisible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // pythonCodeResult:null,
      RunResult: {
        // cmdstr: "代码运行结果",
        // msg: "特定函数调用结果列表"
      },
      // errorMsg: null, //错误信息
      errorText: null, //错误信息
      errorStatus: false,
      sidebarSwitch: true,
      hasRunSuccess: false,
      ifCreateBlock: false,
      runStasus: null,
      running: null, //运行区请求的状态，true表示正在请求
      codeResult: [],
      aiBlockResult: {}, //智能积木对象
      partNumTitleArr: ['标题'], //存放无人小车功能解析的参数
      // hasMediaAttr: false,
      partNumArr: [{ imgArr: [] }], //显示区内容
      // mediaArr: [], //摄像头数组
      // aiBlockArr: [], //摄像头显示的功能
      // audioList: [], //音频功能数组
      codeTextResult: '',
      isFullScreen: false,
      isMeida: null, //是否存在摄像头
      partNum: 1,
      isPart: false, //工作区积木是否有分区积木;
      partIndex: 1, //分区索引
      partWidth: null,
      partHeight: null,
      mediaWidth: null,
      mediaHeight: null,
      clientWidth: null,
      clientHeight: null,
      MediaOffsetTop: null, //摄像头上偏移距离
      MediaOffsetLeft: null, //摄像头左偏移距离
      beMark: false, //遮罩层
      mediaDomain: window.gtaAiConfig.netCameraObj.host,
      Message: {
        runCode: {
          loading: '正在运行中...',
          fail: '运行失败！',
          success: '运行成功！',
          noText: '没有运行的脚本！',
        },
      },

      Icons: {
        NavFile: {
          iconName: '文件',
          viewBox: '0 0 19 18',
          width: '19',
          height: '18',
          iconColor: '#fff',
        },
        NavSave: {
          iconName: '保存',
          viewBox: '0 0 18 19',
          width: '18',
          height: '19',
          iconColor: '#fff',
        },
        ModeCode: {
          iconName: '代码模式',
          viewBox: '0 0 16 15',
          width: '16',
          height: '15',
          iconColor: '#5883ff',
        },
        HeadHelp: {
          iconName: '使用文档',
          viewBox: '0 0 24 24',
          width: '24',
          height: '24',
          iconColor: '#fff',
        },
        // 撤销或重做
        UndoOrRedo: {
          undo: '撤销',
          redo: '重做',
          data: {
            // iconName: "撤销或重做",
            viewBox: '0 0 18 15',
            width: '18',
            height: '15',
          },
        },
        // 桌面整理
        DeskToday: {
          iconName: '整理',
          viewBox: '0 0 17 13',
          width: '17',
          height: '13',
        },
        SidebarSwitch: {
          iconName: '收起',
          viewBox: '0 0 13 14',
          width: '13',
          height: '14',
        },
        CodeRun: {
          iconName: '运行',
          viewBox: '0 0 16 16',
          width: '16',
          height: '16',
        },
        CodeClear: {
          iconName: '清除',
          viewBox: '0 0 16.03 15',
          width: '16.03',
          height: '15',
        },
        RunSuccess: {
          iconName: '运行成功',
          viewBox: '0 0 16 16',
          width: '16',
          height: '16',
        },
        FullScreen: {
          iconName: '全屏',
          viewBox: '0 0 19 19',
          width: '19',
          height: '19',
        },
        ExitFullScreen: {
          iconName: '退出全屏',
          viewBox: '0 0 21 21',
          width: '21',
          height: '21',
        },
        createBlockTextLength: 0, //创建积木脚本长度
        newBlockPythonCode: '', //创建积木脚本长度
      },

      //       codeText:
      //         'import turtle\n' +
      //         "turtle.color('red')\n" +
      //         'wn = turtle.Screen()\n' +
      //         'babbage = turtle.Turtle()\n' +
      //         'babbage.shape("triangle")\n' +
      //         `n = 8\n
      // angle = 360/n\n

      // for i in range(n):\n
      //     babbage.right(angle)\n
      //     babbage.forward(50)\n
      //     babbage.stamp()\n
      // wn.exitonclick()\n` +
      //         'print("hello")',
    }
  },
  //监听属性 类似于data概念
  computed: {
    ...mapGetters(['Train']),
  },

  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getHeightWidth()
  },
  beforeDestroy() {
    // bus.$off('codeRunHandle')
  },
  methods: {
    //skulpt工具运行python脚本
    runIt(codeText) {
      // 页面不能格式化
      let _this = this
      let prog = codeText
      let myPromise
      function builtinRead(x) {
        if (
          Sk.builtinFiles === undefined ||
          Sk.builtinFiles['files'][x] === undefined
        )
          throw "File not found: '" + x + "'"
        return Sk.builtinFiles['files'][x]
      }

      function outf(text) {
        _this.codeResult.push(text)
        console.log('text', text)
      }
      ;(Sk.TurtleGraphics || (Sk.TurtleGraphics = {})).target = 'skulpt-turtle'
      ;(Sk.TurtleGraphics || (Sk.TurtleGraphics = {})).width = _this.clientWidth
      ;(Sk.TurtleGraphics || (Sk.TurtleGraphics = {})).height =
        _this.clientHeight

      Sk.configure({
        output: outf,
        read: builtinRead,
        __future__: Sk.python3,
      })

      myPromise = Sk.misceval.asyncToPromise(function() {
        return Sk.importMainWithBody('<stdin>', false, prog, true)
      })
      myPromise.then(
        function(mod) {
          _this.runStasus = 'success'
        },
        function(err) {
          _this.errorText = err.toString()
          _this.errorStatus = true
          _this.runStasus = 'fail'
          console.log('_this.errorText:', err.toString())
        }
      )
    },
    showError() {
      this.errorStatus = !this.errorStatus
    },
    undoHandle() {
      var undoDom = document.getElementById('btnUndo')
      if (undoDom) {
        undoDom.click()
      }
    },
    redoHandle() {
      var redoDom = document.getElementById('btnRedo')
      if (redoDom) {
        redoDom.click()
      }
    },
    resetSvg() {
      var resetSvgDom = document.getElementById('btnResetSvg')
      if (resetSvgDom) {
        resetSvgDom.click()
      }
    },

    //从文本路径中获取到文本内容
    getTextFromUrl(partIndex, textUrl) {
      let self = this
      let word, text
      this.$axios({
        url: textUrl,
        method: 'get',
        headers: { 'Content-Type': 'application/json;charset=utf-8' },
        // headers: { 'Content-Type': 'application/json' },
        responseType: 'arraybuffer',
      }).then((result) => {
        const iconv = require('iconv-lite')
        const datas = new Uint8Array(result)
        text = iconv.decode(datas, 'gb18030') //解析成字符串

        // let jschardet = require("jschardet")
        // let codeObj = jschardet.detect(text,{ minimumThreshold: 0})
        // console.log('上传的文件encodeing',codeObj);

        console.log('text', text)
        word = text.replace(/\n|\r\n/g, '<br/>')
        self.partNumArr[partIndex - 1].textUrl.push(word)
        self.$forceUpdate()
      })
    },
    /**
      *
      *
     以下为运行前对python脚本解析的方法
     **/
    //分区的宽高
    getHeightWidth() {
      this.clientWidth = document.body.clientWidth
      this.clientHeight = document.body.clientHeight
    },

    //运行积木代码
    codeRunHandle() {
      //在一个请求结束前禁止再次请求
      if (this.running) {
        return
      }
      this.runStasus = null
      //代码运行结果
      var self = this
      self.codeResult = []
      // self.audioList = []
      // this.$emit('runHandle') //直接调用父组件，间接调用BlocklyEditer.vue组件

      this.errorText = ''
      let codeText = this.codeText
      // codeText = this.codeTextHandler(this.codeText)
      if (!this.runStasus && codeText) {
        this.runStasus = 'loading'
      } else if (!codeText) {
        this.runStasus = 'noText'
      }
      if (codeText) {
        //代码运行进行分区运行和显示
        // let status= await this.runPart(codeText)
        // if(status ===false) return;
        //创建积木步骤2  运行积木脚本成功后并分离创建积木的脚本
        // this.splitCreateBlockCode()
        this.runIt(codeText)
        // 执行python后台接口
        // let res = await this.runCode()
        // return res
      }
    },
    codeTextHandler(codeText) {
      let reg_turtle_turtle = /\b(turtle)\b/
      let reg_turtle_pen = /\b(gta_pen)\b/
      if (reg_turtle_pen.test(codeText)) {
        codeText = 'import turtle\n' + 'gta_pen = turtle.Turtle()\n' + codeText
      } else if (reg_turtle_turtle.test(codeText)) {
        codeText = 'import turtle\n' + codeText
      }
      console.log('codeText', codeText)
      return codeText
    },
    //获取标题积木的信息并修改
    getTitleInfo(str, partIndex) {
      str = str.replace('partName=', '').trim()
      var titleArr = eval(str), //字符串转为js对象
        index = eval(titleArr[0]),
        title = titleArr[1]
      if (index <= this.partNumTitleArr.length) {
        this.partNumTitleArr[index - 1] = title
      }
    },
    // 获取新建积木的标志和脚本;
    getCreateBlockInfo(str, partIndex) {
      this.createBlockTextLength = str.length
      return str
    },

    // 分离创建积木的脚本
    splitCreateBlockCode() {
      const reg_create = /CREATEBLOCK\(/
      const { createBlockTextLength } = this
      let newText
      let codeTextResult = this.codeTextResult //被解析的代码
      let tempCodeText = this.codeTextResult //被解析的代码
      const reg_part = /PART/gi
      const splitIndex = codeTextResult.indexOf('CREATEBLOCK')
      // 存在创建积木标志时;去除新建积木标志的脚本
      if (reg_create.test(codeTextResult)) {
        newText = codeTextResult.substr(splitIndex, createBlockTextLength - 1)
        this.ifCreateBlock = true
      } else {
        this.ifCreateBlock = false
      }
      codeTextResult = codeTextResult.replace(newText, '')
      this.codeTextResult = codeTextResult //运行的python脚本

      // 把新建积木后面的脚本(某个功能的脚本)分离出来保存，后面用来表示新建积木的文本功能;
      if (reg_create.test(codeTextResult) !== -1) {
        tempCodeText = codeTextResult.substr(splitIndex, tempCodeText.length)

        // tempCodeText = tempCodeText.substr(
        //   createBlockTextLength,
        //   tempCodeText.length
        // ); //去掉插入
      }
      // tempCodeText 剪切去除分区标志part
      var partTextIndex = tempCodeText.indexOf('part')
      tempCodeText = tempCodeText.substring(0, partTextIndex)
      this.newBlockPythonCode = tempCodeText //保存新建的python脚本
    },

    clearWorkspace() {
      // 清除积木编辑区域
      // this.$refs.blockly.clearWorkspace();
      // 清除运行结果区域
      this.RunResult = {}
      this.runStasus = ''
      this.codeResult = []
      this.clearTurtle()
    },
    //清除海龟库绘图区
    clearTurtle() {
      let canvasList = document.querySelectorAll('#skulpt-turtle canvas')
      if (canvasList && canvasList.length) {
        canvasList.forEach((dom) => {
          this.$util.clearCanvas(dom)
        })
      }
    },
    // 重绘
    sidebarSwitchHandle(val) {
      this.sidebarSwitch =
        val === 'codeRun' ? this.sidebarSwitch : !this.sidebarSwitch
      let switchObj = {
        sidebarSwitch: this.sidebarSwitch,
        type: 'codeRun',
      }
      bus.$emit('onSidebarSwitch', switchObj)
    },
    codeRunSwitchHandler(sidebarSwitch) {
      this.sidebarSwitch = sidebarSwitch
    },
    fullScreen() {
      // TODO: 全屏操作
      this.isFullScreen = !this.isFullScreen
    },
    //确定建积木
    confirmNewBlock() {
      let newBlockPythonCode = this.newBlockPythonCode

      if (this.isPart) {
        this.$alert(
          '工作区有分区积木，新创建的积木只能匹配分区积木上面的积木脚本',
          '注意：',
          {
            confirmButtonText: '确定',
            callback: (action) => {
              bus.$emit('confirmNewBlock', newBlockPythonCode)
            },
          }
        )
      } else {
        bus.$emit('confirmNewBlock', newBlockPythonCode)
      }
    },
  }, // methods end
  updated() {}, //生命周期 - 更新之后
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
@import './PythonCodeRun.scss';
</style>
<style lang="scss">
.el-message-box__wrapper {
  .el-message-box {
    .el-message-box__header {
      margin-top: 30px;
      color: rgba(103, 140, 255, 8);
      padding-bottom: 10px;
    }
    .el-message-box__content {
      text-align: left;
      padding-bottom: -10px !important;
    }
    .el-message-box__btns {
      padding-top: 0px !important;
      button:nth-child(1) {
        background: rgba(103, 140, 255, 1);
      }
    }
  }
}
</style>
